import React, { useEffect } from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const Accommodations: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const handleEmailClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  //   e.preventDefault();
  //   const email = 'emilyandarian@gmail.com';
  //   const subject = 'Accommodations Inquiry';
  //   const body = 'Hello Emily and Arian,\n\nI am interested in booking a room for the wedding. Could you please provide me with more information?\n\nThank you!';
    
  //   // First, try the default email client
  //   window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
  //   // If no email client is available (after 500ms), fall back to Gmail
  //   setTimeout(() => {
  //     const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  //     window.open(gmailUrl, '_blank');
  //   }, 500);
  // };
  return (
    <div id="accommodations">
      <div className="banner-wrapper">
        <Header currentPage="accommodations" />
        <Navigation />
      </div>
      <div className="page-content">
        <div id="accommodations" className="page-heading" style={{fontStyle: 'italic'}}>ACCOMMODATIONS</div>
        <div className="page-small-text" style={{ marginTop: '40px' }}>
          We love our venue because it gives us the opportunity to gather all of our loved ones in one place. We strongly encourage those who are able to stay on the site with us for our special weekend!<br/><br/>
          We have reserved a block of rooms at Wylder Windham, the location for all wedding events. A limited number of rooms are still available at the group rate if you contact us directly.<br/><br/>
          Please note that rooms reserved at the group rate require a two-night stay. Guests who need accommodations for Saturday night only may contact our venue representative, Olivia Meyer, at omeyer@wylderhotels.com or (518) 734-4510 ext. 1005 to inquire about single-night availability.<br/><br/>
          When planning your accommodations, please keep in mind that Uber and other rideshare services may have limited availability in the area.<br/><br/>
        </div>
        {/* <a
          href="mailto:emilyandarian@gmail.com"
          onClick={handleEmailClick}
          className="book-now-btn"
          style={{ fontFamily: 'Baskerville' }}
        >
          Contact Emily & Arian
        </a> */}
      </div>
      <Footer />
    </div>
  );
};

export default Accommodations;
